export const TabId = {
  RuntimeConfigFile: "runtime-config-file",
  Guidelines: "guidelines",
  Preview: "preview",
  Summary: "summary",
  Changes: "changes",
  Dev: "dev",
} as const

export function isTabId(value: string): value is TaskTabId {
  return Object.values(TabId).includes(value as TaskTabId)
}

export type TaskTabId = typeof TabId[keyof typeof TabId]